import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconLayoutRight"><Path d="M3.75 6.75C3.75 5.09315 5.09315 3.75 6.75 3.75L13.25 3.75C14.9069 3.75 16.25 5.09315 16.25 6.75L16.25 17.25C16.25 18.9069 14.9069 20.25 13.25 20.25H6.75C5.09315 20.25 3.75 18.9069 3.75 17.25L3.75 6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M20.25 3.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconLayoutRight;
